import { Suspense, lazy } from 'react'

/**
 * Dev-gated "Open on chart" for EdgeScript code blocks in the chat. The flag
 * expression is repeated inline on purpose (see `flags.ts`): only this shape keeps the
 * language package and the tools out of user builds.
 */
const ButtonImpl =
  import.meta.env.DEV ||
  ((import.meta.env.MODE === 'staging' || import.meta.env.MODE === 'prod') &&
    import.meta.env.VITE_EDGESCRIPT === 'true')
    ? lazy(() => import('./open-script-button').then((m) => ({ default: m.OpenScriptButton })))
    : null

export function LazyOpenScriptButton(props: { source: string }) {
  if (!ButtonImpl) return null
  return (
    <Suspense fallback={null}>
      <ButtonImpl {...props} />
    </Suspense>
  )
}
